"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOREIGN_CURRENCIES_SURCHARGE = exports.AppType = exports.WorkFormat = exports.SessionMeetingDataStatus = exports.WORK_PROFILE_DOMAIN = exports.SessionChangeType = exports.ExamStatus = exports.SessionFormat = exports.InterviewStatus = exports.SessionStatus = exports.ConsulationPaymentType = exports.ServiceVisibleType = void 0;
var ServiceVisibleType;
(function (ServiceVisibleType) {
    ServiceVisibleType["ALL"] = "all";
    ServiceVisibleType["ADMIN"] = "admin";
    ServiceVisibleType["NONE"] = "none";
})(ServiceVisibleType = exports.ServiceVisibleType || (exports.ServiceVisibleType = {}));
var ConsulationPaymentType;
(function (ConsulationPaymentType) {
    ConsulationPaymentType["Tinkoff_old"] = "tinkoff";
    ConsulationPaymentType["Tinkoff"] = "tinkoff_ooo";
    ConsulationPaymentType["Fictive"] = "fictive";
    ConsulationPaymentType["Cloudpayments"] = "cloudpayments";
})(ConsulationPaymentType = exports.ConsulationPaymentType || (exports.ConsulationPaymentType = {}));
var SessionStatus;
(function (SessionStatus) {
    SessionStatus[SessionStatus["Init"] = 0] = "Init";
    SessionStatus[SessionStatus["Paid"] = 1] = "Paid";
    SessionStatus[SessionStatus["Canceled"] = 2] = "Canceled";
    SessionStatus[SessionStatus["InProgress"] = 3] = "InProgress";
    SessionStatus[SessionStatus["Finished"] = 4] = "Finished";
    SessionStatus[SessionStatus["PaidOut"] = 5] = "PaidOut";
    SessionStatus[SessionStatus["Litigation"] = 6] = "Litigation";
    SessionStatus[SessionStatus["Rollbacked"] = 7] = "Rollbacked";
    SessionStatus[SessionStatus["PartiallyPaid"] = 8] = "PartiallyPaid";
})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
var InterviewStatus;
(function (InterviewStatus) {
    InterviewStatus[InterviewStatus["None"] = 0] = "None";
    InterviewStatus[InterviewStatus["Succeed"] = 1] = "Succeed";
    InterviewStatus[InterviewStatus["Failed"] = 2] = "Failed";
    InterviewStatus[InterviewStatus["Contacted"] = 3] = "Contacted";
    InterviewStatus[InterviewStatus["Passed"] = 4] = "Passed";
})(InterviewStatus = exports.InterviewStatus || (exports.InterviewStatus = {}));
var SessionFormat;
(function (SessionFormat) {
    SessionFormat[SessionFormat["Any"] = 0] = "Any";
    SessionFormat[SessionFormat["Online"] = 1] = "Online";
    SessionFormat[SessionFormat["Offline"] = 2] = "Offline";
    SessionFormat[SessionFormat["faceToFace"] = 3] = "faceToFace";
})(SessionFormat = exports.SessionFormat || (exports.SessionFormat = {}));
var ServiceCategory;
(function (ServiceCategory) {
    ServiceCategory[ServiceCategory["Natal"] = 0] = "Natal";
    ServiceCategory[ServiceCategory["Compatibility"] = 1] = "Compatibility";
    ServiceCategory[ServiceCategory["Prediction"] = 2] = "Prediction";
    ServiceCategory[ServiceCategory["Other"] = 3] = "Other";
})(ServiceCategory || (ServiceCategory = {}));
var ExamStatus;
(function (ExamStatus) {
    ExamStatus[ExamStatus["None"] = -1] = "None";
    ExamStatus[ExamStatus["Canceled"] = 0] = "Canceled";
    ExamStatus[ExamStatus["Passed"] = 1] = "Passed";
    ExamStatus[ExamStatus["Failed"] = 2] = "Failed";
})(ExamStatus = exports.ExamStatus || (exports.ExamStatus = {}));
var SessionChangeType;
(function (SessionChangeType) {
    SessionChangeType[SessionChangeType["POSTPONE"] = 0] = "POSTPONE";
    SessionChangeType[SessionChangeType["CANCEL"] = 1] = "CANCEL";
    SessionChangeType[SessionChangeType["POSTPONE_ADMIN"] = 2] = "POSTPONE_ADMIN";
    SessionChangeType[SessionChangeType["CANCEL_ADMIN"] = 3] = "CANCEL_ADMIN";
})(SessionChangeType = exports.SessionChangeType || (exports.SessionChangeType = {}));
var WORK_PROFILE_DOMAIN;
(function (WORK_PROFILE_DOMAIN) {
    WORK_PROFILE_DOMAIN[WORK_PROFILE_DOMAIN["CHRONOS"] = 0] = "CHRONOS";
    WORK_PROFILE_DOMAIN[WORK_PROFILE_DOMAIN["LIFELAB"] = 1] = "LIFELAB";
})(WORK_PROFILE_DOMAIN = exports.WORK_PROFILE_DOMAIN || (exports.WORK_PROFILE_DOMAIN = {}));
var SessionMeetingDataStatus;
(function (SessionMeetingDataStatus) {
    SessionMeetingDataStatus[SessionMeetingDataStatus["NO_ZOOM_ID"] = 0] = "NO_ZOOM_ID";
    SessionMeetingDataStatus[SessionMeetingDataStatus["HAS_ZOOM_ID"] = 1] = "HAS_ZOOM_ID";
})(SessionMeetingDataStatus = exports.SessionMeetingDataStatus || (exports.SessionMeetingDataStatus = {}));
var WorkFormat;
(function (WorkFormat) {
    WorkFormat["indi"] = "indi";
    WorkFormat["direct"] = "direct";
    WorkFormat["admin"] = "admin";
})(WorkFormat = exports.WorkFormat || (exports.WorkFormat = {}));
var AppType;
(function (AppType) {
    AppType["APP"] = "app";
    AppType["MOBILE"] = "mobile";
    AppType["INDI"] = "indi";
    AppType["ADMIN"] = "admin";
    AppType["DAWN"] = "dawn";
})(AppType = exports.AppType || (exports.AppType = {}));
exports.FOREIGN_CURRENCIES_SURCHARGE = 1.1;
